import React from 'react';
import { observer } from 'mobx-react';
import { routerStore } from 'core/routing';

import { analytics } from 'core/analytics';
import { frameStore } from 'apps/components/Frame/appManager';
import { PanelTypes } from 'constants/global';
import { useViewerControl } from 'libs/rendering/gltf/hooks';

import { themes } from 'styles/themes/wikifactoryNew';
import { DiffButtonStyled } from './headerFileFeatures.styled';

type DiffButtonContainerProps = {
  onClick: () => void;
};

export const DiffButtonContainer = observer(
  ({ onClick }: DiffButtonContainerProps) => {
    const { file } = frameStore;

    const viewerControl = useViewerControl();
    const routeParams = routerStore.route.params;
    const { panel } = routeParams;

    if (!file) return null;

    const viewer = viewerControl?.viewer;
    const isDiffing = viewer?.isDiffLoading || viewer?.isDiffing;
    if (!isDiffing) return null;

    const isActive = frameStore.canShowDiffPanel;
    const text = 'Comparison';

    return (
      <DiffButtonStyled
        onClick={() => {
          // @ts-ignore
          analytics.sendEvent('diff-part-click-cad-rooms', {}, { ga: true });
          onClick?.();
        }}
        icon='fork'
        iconPosition='right'
        style={{
          fontWeight: 600,
          background: PanelTypes.includes(panel)
            ? themes.color.wfGrey200
            : themes.color.wfWhite,
          border: 'none',
          borderBottom: `1px solid ${
            isActive ? 'transparent' : themes.color.wfGrey100
          }`,
        }}
        text={text}
        active={isActive}
        appearance='plain'
        removeBold
      />
    );
  },
);
